import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Stack, InputBase, Typography, Checkbox, Button } from "@mui/material";

import { useTranslation } from "react-i18next";
import { startSignIn } from "../../store/auth/thunks";
import { useForm } from "../../hooks";

const loginFormFields = {
    userEmail: '',
    password: '',
}


export const FormLogin = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const {language} = useSelector(state => state.language);
    const [ formValues, handleInputChange ] = useForm(loginFormFields);
    const { userEmail, password } = formValues;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isRememberChecked, setIsRememberChecked] = useState(true);

    const onLogin = (e) => {
        e.preventDefault();
        dispatch(startSignIn(userEmail, password, language, isRememberChecked, searchParams.get('push-token')));
    }

    const handleRecovery = (e) => {
        e.preventDefault();
        navigate('/auth/recover')
    }

    const onRememberChange = (e) => {
        setIsRememberChecked(e.target.checked)
    }

    const { t } = useTranslation('global');
    
    return (
        <Stack width='100%' height='100%' justifyContent='center' alignItems='center'>
            <Stack width='40%' height='70%' maxWidth={476} maxHeight={450} minWidth={268} minHeight={400} bgcolor='white' borderRadius={3} padding='30px 0px' >
                <Typography marginBottom='10px' variant='h5' textAlign='center' fontWeight={700}>{t("login.title")}</Typography>

                <Divider />

                <form onSubmit={onLogin} style={{ padding: '20px 15px', height: '320px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                    <Typography variant='overline' color='secondary'>{t("login.labelUser")}</Typography>
                    <InputBase fullWidth
                        name="userEmail"
                        size="small"
                        variant="standard"
                        onChange={handleInputChange}
                        value={userEmail}
                    />

                    <Typography variant='overline' color='secondary'>{t("login.labelPassword")}</Typography>
                    <InputBase
                        fullWidth
                        name="password"
                        size="small"
                        type="password"
                        onChange={handleInputChange}
                        value={password}
                        autoComplete="off"
                    />

                    <Stack direction='row' alignItems='center' marginLeft='-12px'>
                        <Checkbox defaultChecked onChange={onRememberChange}/>
                        <Typography fontSize={12} variant='subtitle1' color='primary'>{t("login.labelCheckBox")}</Typography>
                    </Stack>

                    <Button type='submit' variant="contained">{t("login.principalButton")}</Button>

                </form>

                <Button variant='text' onClick={handleRecovery} color='primary' fontWeight={700} fontSize='12px' >{t("login.forgetPassword")}</Button>

            </Stack>
        </Stack>
    )
}
